
"use client";

import { HttpTypes } from "@medusajs/types";
import ItemsPreviewTemplate from "@modules/cart/templates/preview";
import Summary from "@modules/cart/templates/summary";

type Props = {
  cart: HttpTypes.StoreCart | null;
  modalCart: HttpTypes.StoreCart | null;
  shippingOptions?: HttpTypes.StoreCartShippingOption[];
};

export default function CartStep({
  cart,
  modalCart,
  shippingOptions = [],
}: Props) {

  if (!cart || !cart.items?.length) {
    return (
      <div className="px-4 py-10 text-center text-sm text-white/60">
        Your cart is empty.
      </div>
    );
  }

  return (
    <div className="rounded-t-2xl border-x border-t border-slate-200 bg-white px-3 py-0 shadow-[0_4px_12px_rgba(15,23,42,0.2)]">

      <ItemsPreviewTemplate cart={modalCart as any} />

      <div className="mt-6 px-2 pt-0 [&_[data-testid='checkout-button']]:hidden">
        <Summary cart={cart as any} shippingOptions={shippingOptions} />
      </div>

    </div>
  );
}
